// Tolt affiliate tracking (script loaded in index.html).
// - window.tolt_referral is set by tolt.js when the visitor arrived through a
//   partner link (?ref=...); the cookie lives on the root domain so it carries
//   over from vivideo.ai to app.vivideo.ai.
// - tolt.signup(email) converts a referred visitor into a lead so Tolt can
//   match them to their Stripe payments later.

declare global {
  interface Window {
    tolt_referral?: string | null;
    tolt?: {
      signup: (email: string) => Promise<unknown>;
    };
  }
}

/** Tolt referral ID for the current visitor, or null if not referred / script blocked. */
export function getToltReferral(): string | null {
  return window.tolt_referral || null;
}

/**
 * Report a new signup to Tolt (no-op when the visitor wasn't referred or the
 * script is blocked by an ad blocker). Never throws — affiliate tracking must
 * not break the auth flow.
 */
export function trackToltSignup(email: string): void {
  if (!email || !window.tolt_referral || !window.tolt?.signup) return;
  try {
    Promise.resolve(window.tolt.signup(email)).catch((err) => {
      console.error('Tolt signup tracking error:', err);
    });
  } catch (err) {
    console.error('Tolt signup tracking error:', err);
  }
}
